import { memo } from 'react';

import { styled } from 'styled-components';

import { cn } from '@/lib/utils';

export const StyledButton = styled.button`
  @keyframes flash {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
  .animation-img {
    animation: flash 2.5s ease infinite;
    will-change: transform;
  }
`;

const base64Img =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDEiIHZpZXdCb3g9IjAgMCA0MCA0MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC4zIiBkPSJNMTQuNjY2NyAwLjY2NjUwNEw0MC4wMDAxIDAuNjY2NTA0TDI1LjMzMzQgNDAuNjY2NUg2LjEwMzUyZS0wNUwxNC42NjY3IDAuNjY2NTA0WiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzMwMV8xMDc0KSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzMwMV8xMDc0IiB4MT0iNy4wMDAwNiIgeTE9IjI1LjY2NjUiIHgyPSIyOS4yMzIzIiB5Mj0iMzEuOTgzOSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSJ3aGl0ZSIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IndoaXRlIiBzdG9wLW9wYWNpdHk9IjAiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K';
const FlashButton = (props) => {
  const { className } = props;

  return (
    <StyledButton
      className={cn(
        `relative flex h-[60px] justify-center items-center text-white text-[24px] w-[276px] bg-[#3177F2] rounded-[100px] overflow-hidden ${props?.disabled ? 'cursor-not-allowed' : 'hover:bg-[#014EFE] cursor-pointer'}`,
        className
      )}
      onClick={props?.onClick}
    >
      {props?.children}
      {!props?.disabled && (
        <img
          src={base64Img}
          alt={'按钮波纹动画'}
          className={'absolute h-[100%] left-[100px] top-[0] w-[100%] animation-img'}
        />
      )}
    </StyledButton>
  );
};

export default memo(FlashButton);
